import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable({ providedIn: 'root' })
export class CompanySettingsAnalyticsService extends AnalyticsBase {
  public readonly namespace = 'CompanySettings';
  public readonly requireViewContext = false;

  public trackCreateCompany(viewContext: 'admin_dropdown' | 'current_user_profile'): void {
    this.track('DialogOpen', {
      view_context: viewContext,
    });
  }

  public trackLeaveCompany() {
    this.track('Leave');
  }

  public trackSignIn(viewContext: 'admin_dropdown' | 'current_user_profile') {
    this.track('SignIn', {
      view_context: viewContext,
    });
  }
}
